import { AnchorHTMLAttributes, DetailedHTMLProps } from "react";
import { Link } from "react-router-dom";
import { getAMapperResolver } from "./resolver";
import { FileComponent } from "./FileComponent";
import { QRCodeComponent } from "./QRCodeComponent";

type AMapperProps = DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>;

export const aMapper = (props: AMapperProps) => {
  const { href, children } = props;

  if (!href) return null;

  const resolver = getAMapperResolver(href);

  if (resolver.name === "file") {
    return <FileComponent {...props} fileType={resolver.fileType} />;
  }

  if (resolver.name === "embed-comps") {
    return <Link to={resolver.href}>{children}</Link>;
  }

  if (resolver.name === "integrations") {
    return <Link to={resolver.href}>{children}</Link>;
  }

  if (resolver.name === "qrcode") {
    return (
      <a href={resolver.href} target="_blank" rel="noreferrer">
        <QRCodeComponent value={resolver.href} size={200}>
          {children}
        </QRCodeComponent>
      </a>
    );
  }

  return <a {...props} target="_blank" rel="noreferrer" />;
};
